import './index.css';
import { CURRENT_ENV } from './Utills/constants';

const ROUTE_PATHS = [
  '?path=getData',
];

const ROUTE_ENDPOINTS = {
  "?path=getData": "?path=getData",
};

function normalizeRoutePath(pathname) {
  const normalizedPath = pathname.replace(/\/+$/, '') || '/';

  return ROUTE_PATHS.find((routePath) => (
    normalizedPath === routePath || normalizedPath.endsWith(routePath)
  )) || normalizedPath;
}

function getRoutePath() {
  const liffState = new URLSearchParams(window.location.search).get('liff.state');

  if (liffState) {
    try {
      const stateUrl = new URL(liffState, window.location.origin);

      return normalizeRoutePath(stateUrl.pathname);
    } catch (error) {
      console.error(error);
    }
  }

  return normalizeRoutePath(window.location.pathname);
}

function getUrlParam(name) {
  const searchParams = new URLSearchParams(window.location.search);
  const value = searchParams.get(name);

  if (value) {
    return value;
  }

  const liffState = searchParams.get('liff.state');

  if (!liffState) {
    return null;
  }

  try {
    return new URL(liffState, window.location.origin).searchParams.get(name);
  } catch (error) {
    console.error(error);
    return null;
  }
}

function getEndpoint(routePath) {

  return ROUTE_ENDPOINTS[routePath] || null;
}

function preloadFlexMessage(endpoint) {
  if (!endpoint) {
    return;
  }

  const url = `${CURRENT_ENV.API_BASE_URL}${endpoint}`;
  window.__LIFF_FLEX_MESSAGE_TASKS__ = window.__LIFF_FLEX_MESSAGE_TASKS__ || new Map();
  window.__LIFF_FLEX_MESSAGE_TASKS__.set(
    endpoint,
    fetch(url, {
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
      },
    }).then((res) => {
      if (!res.ok) {
        throw new Error(`API Error: ${res.status} ${url}`);
      }

      return res.json();
    })
  );
}

const routePath = getRoutePath();
const endpoint = getEndpoint(routePath);

window.__LIFF_ROUTE_PATH__ = routePath;

function mountApp() {
  Promise.all([
    import('react'),
    import('react-dom/client'),
    import('./App')
  ]).then(([React, ReactDOM, { default: App }]) => {
    const root = ReactDOM.createRoot(document.getElementById('root'));

    root.render(
      //<React.StrictMode>
      React.createElement(App)
      //</React.StrictMode>
    );
  });
}

function showLoader() {
  document.getElementById('root').innerHTML = '<section id="loader"><div class="container"><div class="loader"></div><div class="loader"></div><div class="loader"></div></div></section>';
}

if (endpoint) {
  showLoader();
  preloadFlexMessage(endpoint);
  import('./Utills/liffMessage')
    .then(({ sendRouteFlexMessage, showLiffError }) => (
      sendRouteFlexMessage(routePath).catch(showLiffError)
    ))
    .catch(console.error);
} else {
  mountApp();
}
